/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";

import { HealthIndex } from "./HealthIndex";
import { ProfileViewsChange } from "./ProfileViewsChange";

import "./styles.scss";

export interface ISummaryProps {
  statsPrime: any;
  healthIndex?: string | number;
  profileViewsChangeRatio?: number;
  pageType: "OrganizationDashboard" | "FacilityDetails";
}

export const Summary: React.FunctionComponent<ISummaryProps> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityDetailsPage.summary.${key}`);

  const { statsPrime, healthIndex, profileViewsChangeRatio, pageType } = props;

  return (
    <div className={`white-border-panel summary-module padding32`}>
      <div className="titles">{t("summary")}</div>
      {!statsPrime ? (
        <div className="row loading-row">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <ul className="summary-list">
          {healthIndex !== undefined &&
            healthIndex !== null &&
            healthIndex !== "" && (
              <li>
                <HealthIndex healthIndex={healthIndex} pageType={pageType} />
              </li>
            )}
          {profileViewsChangeRatio != null && (
            <li>
              <ProfileViewsChange
                profileViewsChangeRatio={profileViewsChangeRatio}
                pageType={pageType}
              />
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default Summary;
